import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  HostListener,
  Input,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { LoaderService } from 'src/app/common/services/loader.service';
import { SharedPopupService } from 'src/app/common/services/shared-popup.service';
import {
  IsTriggered,
  UploadSubmitObject,
  DefaultPlayButton,
} from 'src/app/common/models/upload.model';
import { CrosstabService } from 'src/app/common/services/crosstab.service';
import { ConfigurationService } from 'src/app/common/services/configuration.service';
import { ClientStudy } from 'src/app/common/models/configurations.model';
import { forkJoin, from, of, Subscription } from 'rxjs';
import { UploadService } from 'src/app/common/services/upload.service';
import { AlertMessageModel, results } from 'src/app/common/models/common.model';
import { AlertMessageService } from 'src/app/common/services/alert-message.service';
import { forEach, orderBy, uniqBy } from 'lodash';
import { Router } from '@angular/router';
import { environment } from 'src/app/environments/environment';
import { COMMON_CONSTANTS_SETTING } from 'src/app/common/constants/common-constants';
import * as JSZip from 'jszip';

@Component({
  selector: 'app-data-upload',
  templateUrl: './data-upload.component.html',
  styleUrls: ['./data-upload.component.scss'],
  //changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DataUploadComponent {
  isLoading: boolean = false;
  isfinalLoadTrigger: boolean = false;
  isToggleDropdown: boolean = false;
  ActiveModule1: boolean = false;
  ActiveModule2: boolean = false;
  selectedStudy: string = '';
  isErrorpopupshown: boolean = false;
  selectedClientStudies: string[] = [];
  selectedClientStudies_MasterData: string[] = [];
  isclientSelected: boolean = false;
  isDataUpdateSelected: boolean = false;
  isDataSourceSelected: boolean = false;
  isDataFormatSelected:boolean = false;
  isStudySelected: boolean = false;
  showEmailPopup: boolean = false;
  emailList: any = [];
  adminEmailIDList: any = [];
  nonadminEmailIDList: any = [];
  emailExistingList = [];
  getNewEmailList: boolean = false;
  searchTermAdmin: string = '';
  searchTermOthers: string = '';
  enableEmailSubmit: boolean = false;
  submittedAdminEmailList: any = [];
  submittedOthersEmailList: any = [];
  RestatementNotAllowed: boolean = false;
  showSettingDropdown : boolean = false;
  notAuthorized : boolean = false;
  confirmationType : any ;
  confirmationMessage : string = "";
  isShowDialog : boolean = false;
  
  // Report Issue Popup properties
  isReportIssue: boolean = false;
  settingOptionList = COMMON_CONSTANTS_SETTING;
  
  Filetypes : any
  FiletypesForRespondent = [
    { filetype: 'CRDOM', is_selected: false },
    { filetype: 'CSV', is_selected: false },
    { filetype: 'GDF', is_selected: false },
    { filetype: 'SPSS', is_selected: false },
  ];

  settingIconsButton = [
    { iconName : 'Delete', isSelected : false, iconId : 'delete'},
    { iconName : 'Download', isSelected : false, iconId : 'download'},
    { iconName : 'Email List', isSelected : false, iconId : 'email_list'},
    { iconName : 'User Log', isSelected : false, iconId : 'user_log'},
    { iconName : 'Trigger Alerts', isSelected : false, iconId : 'trigger_alerts'},
  ]
  FiletypesForAggregated = [
    { filetype: 'CSV', is_selected: false },
    { filetype: 'SPSS', is_selected: false },
  ];

  DataFormat = [
    { dataFormatType : 'Respondent level', value : 'respondent', is_selected : false , disabled: false },
    { dataFormatType : 'Aggregated/Semi Aggregated', value : 'aggregated', is_selected : false , disabled: false },
  ]

  DataProcessTypes = [
    {
      process: 'Regular Data / Mapping Update',
      type: 'upload',
    },
    {
      process: 'Restatement',
      type: 'restatement',
    },
  ];

  DataSource = [
    {
      name: 'Brand Health',
      type: 'brand-health',
    },
  ];

  Folders = {
    inclusion: ['inclusion', 'new-variable-mapping'],
    timeperiod: ['timeperiod.zip'],
  };

  // selectedDeletes: { [key: string]: boolean } = {
  //   entireStudyData: false,
  //   inclusionExclusionFile: false,
  //   variableMappingFile: false,
  //   crosstabFOMMappingFile: false,
  //   brandAnalysisFOMMappingFile: false,
  //   snapshotFOMMappingFile: false,
  //   timeperiodMappingFile: false,
  // };

  selectedDeletes = [{
    displayName  : 'Entire Study Data',
    isSelected : false,
    id : "all",
  },{
    displayName  : 'Inclusion/Exclusion file',
    isSelected : false,
    id : "ie",
  },{
    displayName  : 'Variable Mapping file',
    isSelected : false,
    id : "vm",
  },{
    displayName  : 'Crosstab FOM Mapping file',
    isSelected : false,
    id : "cfom",
  },{
    displayName  : 'Brand Analysis FOM Mapping file',
    isSelected : false,
    id : "bafom",
  },{
    displayName  : 'Snapshot FOM Mapping file',
    isSelected : false,
    id : "sfom",
  },{
    displayName  : 'Timeperiod Mapping file',
    isSelected : false,
    id : "tpm",
  }]

  selectedAlerts = [{
    displayName  : 'DEV Server',
    isSelected : false,
    id : "dev",
  },{
    displayName  : 'UAT Server',
    isSelected : false,
    id : "uat",
  },{
    displayName  : 'PROD Server',
    isSelected : false,
    id : "prod",
  },{
    displayName  : 'DEMO Server',
    isSelected : false,
    id : "demo",
  }]

  FileFormat: any;
  UploadObject: any;
  UserClientStudyData: any;
  UserClientStudyData_MasterData: any;
  Is_Submit: boolean = false;
  totalfiles: any;
  file: any;
  IsUploadFileStatus: any = [];
  intervalId: any;
  StatusUpdate = {
    section1: true,
    section2: false,
    section3: false,
    section4: false,
    section5: false,
    section6: false,
    section7: false,
    section9: false,
  };
  validuploadFileName: string = '';
  public SubmitObject: UploadSubmitObject = {
    Client: '',
    study: '',
    dataProces: '',
    filetype: '',
  };
  isTriggered: IsTriggered = {
    section1: false,
    section2: false,
    section3: false,
    section4: false,
    section5: false,
    section6: false,
    section7: false,
    section9: false,
  };
  indexCount: number = 0;
  isFilenotAvailable: boolean = true;
  fomInputPlayButtonEnable: boolean = true;
  fomFilePlayButtonEnable: boolean = true;
  timePeriodPlayButtonEnable: boolean = true;
  isButtonDisableWhenClickOnTrigger = true;
  items = [1, 2, 3, 4, 5, 6, 7, 8];
  dropdownSelection = {
    client_name: '',
    study: '',
    dataProces: '',
    dataSource: '',
    fileType: '',
    JobType: '',
    FolderName: '',
    dataFormat : '',
  };

  dropdownSelectedText = {
    client_name: '',
    study: '',
    dataProces: '',
    dataSource: '',
    fileType: '',
    JobType: '',
    FolderName: '',
    dataFormat : '',
  };

  
  IsUatLoadSelected : boolean = false;
  IsProdLoadSelected : boolean = false;
  IsDemoLoadSelected : boolean = false;
  selectedEnvironment : string = "";
  isTPMtoggleClicked : boolean = false;
  isFOMtoggleClicked : boolean = false;
  isTPMtoggleOn : boolean = false;

  $unSubscribeSubmitData1!: Subscription;
  @Input() userManagementShown: boolean = false;
  @Input() excelExport: boolean = false;
  @Input() helpGuide: boolean = false;
  @Input() pptExport: boolean = false;
  @Input() repository: boolean = false;
  @Input() exportDownloads: boolean = false;
  @ViewChild('dataSanityRawDataConfig') dataSanityRawDataConfig:
    | ElementRef
    | undefined;
  @ViewChild('ChooseFile') sanityInputFile: ElementRef | undefined;

  //@Input() landingdata: any;
  selectedmoduleCell: number | null = null;
  statusdata: any;
  inputFileName = {
    sanityInput: 'Choose File from system',
    inclusionInput: 'Inclusion File (New variable list)',
    mappingInput: 'Mapping File',
    timeperiodInput: 'TP inputs file* and Suppress file',
    fomInput: '',
    fomFile: '',
    finalLoadInput: 'Choose File from system',
  };
  BindFileName = {
    sanityInput: '',
    inclusionInput: '',
    mappingInput: '',
    timeperiodInput: '',
    fomInput: '',
    fomFile: '',
    finalLoadInput: '',
  };

  defaultPlayButton: DefaultPlayButton = {
    section1: true,
    section2: true,
    section3: true,
    section4: true,
    section5: true,
    section6: true,
    section7: true,
    section8: true,
    section9: true,
  };

  DeleteIndexTypes = [
    {
      IndexName: 'FOM Mapping',
      originalIndexName: 'fom_mapping_data',
      is_selected: false,
    },
    {
      IndexName: 'Time Period Mapping',
      originalIndexName: 'time_period_mapping_data',
      is_selected: false,
    },
    {
      IndexName: 'Grid Status',
      originalIndexName: 'file_upload_status',
      is_selected: false,
    },
  ];

  client_details_from_landing?: ClientStudy;
  
  Is_SubmitClick: boolean = false;

  showUploadGrid: boolean = true;
  intervalTime = 5000;
  secondPopupEnabled: boolean = false;
  selectedIdsString: string="";
  configData: any;
  configDataFormat: any;
  isDataFormatDropdownDisabled = false;

  constructor(
    public SharedService: SharedPopupService,
    private Loader: LoaderService,
    private crossTabService: CrosstabService,
    private uploadService: UploadService,
    private renderer: Renderer2,
    private _alertService: AlertMessageService,
    private router : Router,
    private _configService: ConfigurationService,
  ) {
    if(!environment.showUploadModule){
      this.router.navigateByUrl('landing');
    }
    this.client_details_from_landing = this.router.getCurrentNavigation()?.extras.state as ClientStudy;
  }
  ngOnInit() {
    this.selectedmoduleCell = 1;
    this.BindFileName.sanityInput = this.inputFileName.sanityInput;
    this.BindFileName.inclusionInput = this.inputFileName.inclusionInput;
    this.BindFileName.mappingInput = this.inputFileName.mappingInput;
    this.BindFileName.timeperiodInput = this.inputFileName.timeperiodInput;
    this.BindFileName.fomInput = this.inputFileName.fomInput;
    this.BindFileName.fomFile = this.inputFileName.fomFile;
    this.BindFileName.finalLoadInput = this.inputFileName.finalLoadInput;

    this.getAllowedClientDetails();
  }
  ngAfterViewInit() {
    if (this.Is_Submit) {
      this.renderer.setStyle(
        this.dataSanityRawDataConfig?.nativeElement,
        'opacity',
        '100%'
      );
    }
  }

  getAllowedClientDetails() {
    this.isLoading = true;
    this.uploadService.AllowedClientDetails().subscribe((result: any) => {
      if (result) {
        this.getUserClientStudy(result);
      }
      // this.isLoading = false;
    });
  }

  toggleDropDown() {
    this.isToggleDropdown = !this.isToggleDropdown;
  }

  getSectionActive(section: any) {
    if (this.statusdata != undefined) {
      if (this.statusdata.length > 0) {
        switch (section) {
          case 'section1':
            if (this.statusdata.length > 0) {
              if (this.statusdata[0].consumable_file_flag) {
                this.StatusUpdate.section1 = true;
                if (
                  this.totalfiles == undefined ||
                  this.totalfiles.length == 0
                ) {
                  this.BindFileName.sanityInput =
                    this.inputFileName.sanityInput;
                }
                return true;
              } else {
                this.StatusUpdate.section1 = false;
                this.renderer.setStyle(
                  this.dataSanityRawDataConfig?.nativeElement,
                  'opacity',
                  '0.5'
                );
                return false;
              }
            } else {
              return true;
            }

          case 'section2':
            if (this.statusdata[0].inclusion_file_flag) {
              this.StatusUpdate.section2 = true;
              return true;
            } else {
              this.StatusUpdate.section2 = false;
              return false;
            }
          case 'section3':
            if (this.statusdata[0].variable_mapping_flag) {
              this.StatusUpdate.section3 = true;
              return true;
            } else {
              this.StatusUpdate.section3 = false;
              return false;
            }
          case 'section4':
            if (this.statusdata[0].tp_flag) {
              this.StatusUpdate.section4 = true;
              return true;
            } else {
              this.StatusUpdate.section4 = false;
              return false;
            }
          case 'section5':
            if (this.statusdata[0].fom_flag) {
              this.StatusUpdate.section5 = true;
              return true;
            } else {
              this.StatusUpdate.section5 = false;
              return false;
            }
          case 'section6':
            if (this.statusdata[0].fom_input_flag) {
              this.StatusUpdate.section6 = true;
              return true;
            } else {
              this.StatusUpdate.section6 = false;
              return false;
            }
          case 'section7':
            if (this.statusdata[0].fom_file_flag) {
              this.StatusUpdate.section7 = true;
              return true;
            } else {
              this.StatusUpdate.section7 = false;
              return false;
            }
          case 'section9':
            if (this.statusdata[0].fd_flag) {
              this.StatusUpdate.section9 = true;
              return true;
            } else {
              this.StatusUpdate.section9 = false;
              return false;
            }
          // Add more cases as needed
          default:
            if (this.statusdata[0].consumable_file_flag) {
              return true;
            } else {
              return false;
            }
        }
      } else {
        return this.enableSection(section);
      }
    }
    // else{
    //   if(section === "section1"){
    //     this.StatusUpdate.section1= true;
    //     return true;
    //   }
    // }
    return false;
  }
  enableSection(section: any) {
    switch (section) {
      case 'section1':
        this.StatusUpdate.section1 = true;
        return true;
      case 'section2':
        return false;

      case 'section3':
        return false;

      case 'section4':
        this.StatusUpdate.section4 = false;
        return false;

      case 'section5':
        this.StatusUpdate.section5 = false;
        return false;
      case 'section6':
        this.StatusUpdate.section6 = false;
        return false;

      // Add more cases as needed
      default:
        return false;
    }
  }

  DownloadUsageLogReport() {
    this.isLoading = true;
    let clientName = this.UploadObject[0].client_name;
    let studyName = this.UploadObject[0].study;
    let fileType = this.UploadObject[0].fileType;
    let dataSource = this.UploadObject[0].dataSource;
    let dataProcess = this.UploadObject[0].dataProces;
    this.uploadService
      .ExcelExportForUsageLog(
        clientName,
        studyName,
        dataSource,
        dataProcess,
        fileType
      )
      .subscribe(
        (excelBlob: Blob) => {
          let fileName =
            clientName +
            '_' +
            studyName +
            '_' +
            dataSource +
            '_' +
            dataProcess +
            '_' +
            fileType +
            '_Usage Log.xlsx';
          // Trigger file download
          this.downloadFile(excelBlob, fileName);
          this.isLoading = false;
        },
        (error) => {
          console.error('Error exporting to Excel', error);
          this.errorPopup('Something went wrong, please try again');
          this.isLoading = false;
        }
      );
    // this.uploadService.ExcelExportForUsageLog(clientName, studyName, fileType).subscribe((exportFile) => {
    //   this.isLoading = false;
    //   const blob = new Blob([exportFile], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    //   const Url = window.URL.createObjectURL(blob);
    //   const anchor = document.createElement('a');
    //   anchor.download = clientName+"_"+studyName+'_Usage Log.xlsx';
    //   anchor.href = Url;
    //   anchor.click();
    // }, (fileDownloadError:any) => {
    //   this.isLoading = false;
    //   this.errorPopup(fileDownloadError);
    //   this.isErrorpopupshown = true;
    // });
  }

  private downloadFile(data: Blob, filename: string) {
    const blob = new Blob([data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = filename;

    // Trigger download
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }

  getSectionStatus(section: string, IsIconChange: boolean): any {
    if (this.statusdata != undefined) {
      switch (section) {
        case 'section1':
          // this.renderer.setStyle(this.dataSanityRawDataConfig?.nativeElement, "opacity", "100%");
          return this.statusdata.length > 0
            ? IsIconChange
              ? this.IsIconChange(this.statusdata[0].consumable_file_status)
              : this.statusdata[0].consumable_file_status
            : this.IsIconChange('not started');

        case 'section2':
          return this.statusdata.length > 0
            ? IsIconChange
              ? this.IsIconChange(this.statusdata[0].inclusion_file_status)
              : this.statusdata[0].inclusion_file_status
            : this.IsIconChange('not started');
        case 'section3':
          return this.statusdata.length > 0
            ? IsIconChange
              ? this.IsIconChange(this.statusdata[0].variable_mapping_status)
              : this.statusdata[0].variable_mapping_status
            : this.IsIconChange('not started');
        case 'section4':
          return this.statusdata.length > 0
            ? IsIconChange
              ? this.IsIconChange(this.statusdata[0].tp_status)
              : this.statusdata[0].tp_status
            : this.IsIconChange('not started');
        case 'section5':
          return this.statusdata.length > 0
            ? IsIconChange
              ? this.IsIconChange(this.statusdata[0].fom_block_status)
              : this.statusdata[0].fom_block_status
            : this.IsIconChange('not started');
        case 'section6':
          return this.statusdata.length > 0
            ? IsIconChange
              ? this.IsIconChange(this.statusdata[0].fom_input_status)
              : this.statusdata[0].fom_input_status
            : this.IsIconChange('not started');
        case 'section7':
          return this.statusdata.length > 0
            ? IsIconChange
              ? this.IsIconChange(this.statusdata[0].fom_file_status)
              : this.statusdata[0].fom_file_status
            : this.IsIconChange('not started');
        case 'section9':
          return this.statusdata.length > 0
            ? IsIconChange
              ? this.IsIconChange(this.statusdata[0].final_block_status)
              : this.statusdata[0].final_block_status
            : this.IsIconChange('not started');
        case 'sanity':
          return this.statusdata.length > 0
            ? this.statusdata[0].data_sanity_status
            : 'not started';
        case 'IS':
          return this.statusdata.length > 0
            ? this.statusdata[0].fom_block_status == 'completed' &&
              this.statusdata[0].tp_status == 'completed'
              ? 'completed'
              : this.statusdata[0].data_sanity_status != 'completed'
              ? 'not started'
              : this.statusdata[0].fom_block_status == '' &&
                this.statusdata[0].tp_status == ''
              ? 'not started'
              : 'in-progress'
            : 'not started';
        // Add more cases as needed
        case 'finalDataLoad':
          return this.statusdata.length > 0
            ? this.statusdata[0].final_block_status
            : 'not started';
        default:
          return 'Start';
      }
    }
    return '';
  }
  getStatusColor(section: string): string {
    // Map status to corresponding CSS class
    let status = this.getSectionStatus(section, false).toLowerCase();
    switch (status) {
      case 'in-progress':
        return '#FF971E';
      case 'failed':
        this.clearFileInput(section);
        return '#DB4F45';
      case 'completed':
        this.clearFileInput(section);
        return '#3BC47C';
      default:
        return '';
    }
  }
  getStatusIcon(section: string): string {
    let status: any;

    if (this.getSectionActive(section)) {
      status = this.getSectionStatus(section, true).toLowerCase();
    } else {
      status = this.getSectionStatus(section, false).toLowerCase();
    }
    switch (status) {
      case 'in-progress':
        return 'schedule';
      case 'failed':
        return 'cancel';
      case 'completed':
        return 'check_circle';
      default:
        return 'play_circle';
    }
  }
  IsIconChange(sectionStatus: string) {
    if (sectionStatus == 'in-progress') {
      return sectionStatus;
    } else if (sectionStatus == 'failed') {
      return sectionStatus;
    } else if (sectionStatus == 'completed') {
      return sectionStatus;
    } else {
      return 'start';
    }
  }
  getUploadDisableStatus(section: string) {
    let status = this.getSectionStatus(section, false).toLowerCase();

    if (section == 'section1' && status == 'completed') {
      this.isTriggered[section] = false;
      return false;
    } else {
      if (this.statusdata != undefined) {
        if (!this.statusdata.fom_flag) {
          if (section == 'section7' && status == 'completed') {
            this.isTriggered[section] = false;
            return false;
          } else if (section == 'section6' && status == 'completed') {
            this.isTriggered[section] = false;
            return true;
          }
        }
      }
    }
    switch (status) {
      case 'in-progress':
        this.isTriggered[section] = true;
        return true;
      case 'failed':
        this.isTriggered[section] = false;
        return false;
      case 'completed':
        this.isTriggered[section] = false;
        return true;
      default:
        //this.isTriggered[section] = false;
        return false;
    }
  }
  getUserClientStudy(allowedData: any): void {
    //this.isLoading = true;
    this.FileFormat = this.Filetypes;
    this.SharedService.getClientList().subscribe((result) => {
      if (result.HasValidData) {
        let data = JSON.parse(result.Data);
        data = orderBy(data, [(s) => s['ClientName'].toLowerCase()]);

        data = data.filter((s: any) => {
          return allowedData.includes(s.ClientName);
        });

        if (data.length > 0) {
          this.UserClientStudyData_MasterData = data;
          this.UserClientStudyData = data;
        } else {
          this.isLoading = false;
          //this.router.navigateByUrl('landing');
          this.errorPopup('You dont have access for any client study upload');
          this.notAuthorized = true;
        }
      }
      this.isLoading = false;
    });
  }

  OnRadioToggle(query: any) {
    if (query) {
      query.is_selected = !query.is_selected;
    }
  }

  OnRadioModuleToggle(file: any) {
    this.UploadObject = [];
    // Set the is_selected property of the clicked module to true
    file.is_selected = true;

    // Find any other selected module and set its is_selected property to false
    let otherSelected = this.FileFormat.find(
      (x: any) => x.is_selected && x.filetype !== file.filetype
    );
    if (otherSelected != null && otherSelected != undefined) {
      otherSelected.is_selected = false;
    }
    // Update the user's moduleName with the selected module's module_name
    this.SubmitObject.Client = 'PMI';
    this.SubmitObject.filetype = file.filetype;
    this.SubmitObject.study = 'NCPT';

    this.UploadObject.push(this.SubmitObject);
    // Trigger the update of the clientStudyName based on the new moduleName
  }

  OnDeleteClick() {
    this.isLoading = true;
    this.selectedIdsString = this.selectedDeletes
    .filter(item => item.isSelected)
    .map(item => item.id)
    .join(',');
    let client_study_name = this.UploadObject[0].study;
    let filetype = this.UploadObject[0].fileType;

    // const selectedTypes = Object.keys(this.selectedDeletes).filter(
    //   (key) => this.selectedDeletes[key]
    // )

    this.uploadService
      .deleteIndex(
        'test-folder-creation',
        client_study_name,
        filetype,
        this.selectedIdsString,
      )
      .subscribe(
        (res: any) => {
          if (res.HasValidData) {
            this.isLoading = false;
            this.errorPopup(res.Data, '');
            this.isToggleDropdown = false;
            this.DeleteIndexTypes.map((item) => {
              item.is_selected = false;
            });
            // Resolve the promise with the response
          } else {
            this.isLoading = false;
            if (!this.isErrorpopupshown) {
              this.errorPopup(res.ExceptionMessage);
              this.isErrorpopupshown = true;
            }
          }
        },
        (error) => {
          this.isLoading = false;
        }
      );
  }

  toggleDeleteOption(option: string): void {
    // this.selectedDeletes[option] = !this.selectedDeletes[option];
    this.selectedDeletes.forEach((item:any) => {
      if( item.id === option){
        item.isSelected = !item.isSelected;
      }
    })
  }
  
  toggleAlertOption(option: string): void {
    this.selectedAlerts.forEach((item:any) => {
      if( item.id === option){
        item.isSelected = !item.isSelected;
      }
    })
  }
  resetfileName(){
    this.BindFileName.sanityInput = this.inputFileName.sanityInput;
    this.BindFileName.inclusionInput = this.inputFileName.inclusionInput;
    this.BindFileName.mappingInput = this.inputFileName.mappingInput;
    this.BindFileName.timeperiodInput = this.inputFileName.timeperiodInput;
    this.BindFileName.fomInput = this.inputFileName.fomInput;
    this.BindFileName.fomFile = this.inputFileName.fomFile;
    this.BindFileName.finalLoadInput = this.inputFileName.finalLoadInput;
  }
  
  OnSubmitClick() {
    this.resetfileName();
    this.isToggleDropdown = false;
    this.isTPMtoggleOn = false;
    this.isTPMtoggleClicked = false;
    this.hideMainDropDown('');
    if (this.intervalId != null && this.intervalId != undefined) {
      clearInterval(this.intervalId);
    }
    this.isErrorpopupshown = false;
    this.Is_SubmitClick = true;
    // if(this.UploadObject.length > 0){
    //   this.Is_Submit = true;
    //   this.indexCount = 0;
    //   }
    this.uploadService.$submitClickEvent.next(true);

    if (
      this.dropdownSelection.client_name != '' &&
      this.dropdownSelection.study != '' &&
      this.dropdownSelection.dataProces != '' &&
      this.dropdownSelection.dataSource != '' &&
      this.dropdownSelection.fileType != ''
    ) {
      this.UploadObject = [];
      this.UploadObject.push(this.dropdownSelection);
      if (this.UploadObject.length > 0) {
        this.RestatementNotAllowed = false;

        this.getNewEmailList = true;
        this.isLoading = true;
        this.statusdata = [];

        //const selectedsubmitdata = JSON.parse(JSON.stringify(this.UploadObject[0]));

        this.showUploadGrid =
          this.dropdownSelection.dataProces == 'upload' ? true : false;

        const emailCall = of(this.getEmailIdList());
        const submitDataCall = this.starthttprequest(this.UploadObject[0]);

        forkJoin({ r1: emailCall, r2: submitDataCall }).subscribe(
          (s: any) => {}
        );
      }
    }
  }
  clearFileInput(section: string): void {
    if (this.sanityInputFile) {
      this.sanityInputFile.nativeElement.value = '';
    }
  }

  starthttprequest(data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.$unSubscribeSubmitData1 = this.uploadService
        .datauploadstatusandgriddata(data)
        .subscribe(
          (res: any) => {
            if (res.HasValidData) {
              let jsonData = res;
              let finalData = null;
              this.isLoading = false;
              if (jsonData.Data.length > 0) {
                finalData = JSON.parse(jsonData.Data);
                this.statusdata = finalData[0];
                this.statusdata.sort((a: any, b: any) => b.sort_id - a.sort_id);
              } else {
                this.statusdata = [];
              }
              this.RestatementNotAllowed = false;

              resolve(res); // Resolve the promise with the response
            } else {
              this.isLoading = false;
              if (!this.isErrorpopupshown) {
                this.errorPopup(res.ExceptionMessage);

                this.isErrorpopupshown = true;
                clearInterval(this.intervalId);
                if (this.dropdownSelection.dataProces == 'restatement') {
                  this.RestatementNotAllowed = true;
                  this.Is_SubmitClick = false;
                  this.showUploadGrid = true;
                } else {
                  this.RestatementNotAllowed = false;
                }
              }
              reject(new Error(res.ExceptionMessage)); // Reject the promise with the error message
            }
          },
          (error) => {
            this.isLoading = false;
            reject(error); // Reject the promise with the error
          }
        );
    });
  }
  errorPopup(message: string, headerTxt: string = 'Error'): void {
    const alertObj: AlertMessageModel = {
      header: headerTxt,
      message: message,
      show: true,
    };
    this._alertService.showAlert(alertObj);
  }

  checkFileName(event: any, section: string) {
    this.validuploadFileName = '';
    let selectedSubmitData = JSON.parse(JSON.stringify(this.UploadObject[0]));
    let clientName: string = selectedSubmitData.client_name.toLowerCase();
    clientName = clientName.replace(/\s+/g, '-');

    clientName = clientName.trim().replaceAll(" ","-")
    selectedSubmitData.study = selectedSubmitData.study.trim().replaceAll(" ","-");
    switch (section) {
      case 'section1':
        this.validuploadFileName = `RawData.zip`;
        return event.target.files[0].name == `RawData.zip`;
      case 'section2':
        this.validuploadFileName = `${clientName.toLowerCase()}_${selectedSubmitData.study.toLowerCase()}_IE_FILE.csv`;
        return (
          event.target.files[0].name ==
          `${clientName.toLowerCase()}_${selectedSubmitData.study.toLowerCase()}_IE_FILE.csv`
        );
      case 'section3':
        this.validuploadFileName = `${clientName.toLowerCase()}_${selectedSubmitData.study.toLowerCase()}_Variable_Mapping.xlsx`;

        return (
          event.target.files[0].name ==
          `${clientName.toLowerCase()}_${selectedSubmitData.study.toLowerCase()}_Variable_Mapping.xlsx`
        );
      case 'section4':
        this.validuploadFileName = this.isTPMtoggleClicked ? `${clientName.toLowerCase()}_${selectedSubmitData.study.toLowerCase()}_tpm_variable_mapping.xlsx` : `timeperiod.zip`;
        return this.isTPMtoggleClicked 
        ? event.target.files[0].name == `${clientName.toLowerCase()}_${selectedSubmitData.study.toLowerCase()}_tpm_variable_mapping.xlsx`  
        : event.target.files[0].name == `timeperiod.zip`;
      case 'section5':
        this.validuploadFileName = `${clientName.toLowerCase()}_${selectedSubmitData.study.toLowerCase()}_fom_Inputsfile.xlsx`;
        return (
          event.target.files[0].name ==
          `${clientName.toLowerCase()}_${selectedSubmitData.study.toLowerCase()}_fom_Inputsfile.xlsx`
        );
      case 'section7':
        this.validuploadFileName = `${clientName.toLowerCase()}_${selectedSubmitData.study.toLowerCase()}_fom_mapping.xlsx`;
        return (
          event.target.files[0].name ==
          `${clientName.toLowerCase()}_${selectedSubmitData.study.toLowerCase()}_fom_mapping.xlsx`
        );
      case 'section9':
        this.validuploadFileName = `Config_Final.xlsx`;
        return event.target.files[0].name == `Config_Final.xlsx`;
    }

    return false;
  }

  onFileInput(event: any, section: string) {
    if (section != 'section1' && section != 'section4') {
      if (
        event.target.files[0] &&
        event.target.files[0].type === 'application/x-zip-compressed'
      ) {
        this.errorPopup('ZIP files are not allowed.');
        event.target.value = ''; // Clear the file input
      }
    }

    if( this.isTPMtoggleClicked && section == 'section4'){
      if(event.target.files[0] &&
        event.target.files[0].type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' &&
        event.target.files[0].type !== 'application/vnd.ms-excel'){
        this.errorPopup('Only Excel files are allowed')
        event.target.value = ''
        return;
      }
    }
    else if( !this.isTPMtoggleClicked && section == 'section4'){
      if (
        event.target.files[0] &&
        event.target.files[0].type !== 'application/x-zip-compressed'
      ) {
        this.errorPopup('Only ZIP files are allowed.');
        event.target.value = ''; // Clear the file input
        return;
      }
    }
    this.validuploadFileName = '';
    if (!this.checkFileName(event, section)) {
      this.errorPopup(
        'Please follow FileName Nomenclature (' + this.validuploadFileName + ')'
      );
      event.target.value = '';
      return;
    }

    this.UpdateFileName(event, section);
    this.GetFileList(event.target.files);
    this.defaultPlayButton[section] = true;
    if (this.totalfiles.length > 0) {
      if (section == 'section5') {
        this.fomInputPlayButtonEnable = false;
      } else if (section == 'section7') {
        this.fomFilePlayButtonEnable = false;
      } else if (section == 'section9') {
        this.isfinalLoadTrigger = false;
      } else if (section == 'section4') {
        this.timePeriodPlayButtonEnable = false;
      } else {
        this.isFilenotAvailable = false;
      }
      this.isButtonDisableWhenClickOnTrigger = false;
    }
  }

  GetFileList(files: any) {
    this.totalfiles = [];
    for (let index = 0; index < files.length; index++) {
      this.file = files[index];
      this.totalfiles.push(this.file);
    }
  }

  UpdateFileName(event: any, section: string) {
    switch (section) {
      case 'section1':
        this.BindFileName.sanityInput = event.target.files[0].name;
        break;
      case 'section2':
        this.BindFileName.inclusionInput = event.target.files[0].name;
        break;
      case 'section3':
        this.BindFileName.mappingInput = event.target.files[0].name;
        break;
      case 'section4':
        this.BindFileName.timeperiodInput = event.target.files[0].name;
        break;
      case 'section5':
        this.BindFileName.fomInput = event.target.files[0].name;
        break;
      case 'section7':
        this.BindFileName.fomFile = event.target.files[0].name;
        break;
      default:
        this.BindFileName.finalLoadInput = event.target.files[0].name;
        break;
    }
  }
  onTrigger(section: string, folderName: string) {
    this.isErrorpopupshown = false;
    this.isTriggered[section] = true;
    this.defaultPlayButton[section] = false;

    if (this.totalfiles !== undefined && this.totalfiles.length > 0) {
      this.dropdownSelection.JobType = this.getJobNameBasedOnSection(section);
      this.dropdownSelection.FolderName = folderName;
      this.isLoading = true;
      this.isButtonDisableWhenClickOnTrigger = true;
      if (section == 'section6') {
        this.fomInputPlayButtonEnable = true;
      } else if (section == 'section7') {
        this.fomFilePlayButtonEnable = true;
      } else if (section == 'section4') {
        this.timePeriodPlayButtonEnable = true;
      } else if (section == 'section9') {
        this.isfinalLoadTrigger = true;
      } else {
        this.isFilenotAvailable = true;
      }

      let isToggleOn = false;
      if(section == "section4"){
        isToggleOn = this.isTPMtoggleClicked;
        this.isTPMtoggleOn = true;
      }
      if(section =='section7'){
        isToggleOn = this.isFOMtoggleClicked;
      }

      let emailData: any = this.uploadService.getStoredEmailListData();

      this.uploadService
        .fileUpload(
          this.dropdownSelection,
          this.totalfiles,
          folderName,
          emailData,
          this.selectedEnvironment,
          isToggleOn
        )
        .subscribe(
          async (result: any) => {
            // Validate the response
            if (result.HasValidData) {
              this.IsUatLoadSelected = false;
              this.IsProdLoadSelected = false;
              this.IsDemoLoadSelected = false;
              this.isTPMtoggleClicked = false;
              this.isTPMtoggleOn = false;
              this.isTPMtoggleClicked = false;
              if (this.UploadObject.length > 0) {
                this.totalfiles = [];
                let selectedsubmitdata = JSON.parse(
                  JSON.stringify(this.UploadObject[0])
                );
                clearInterval(this.intervalId);
                this.intervalId = setInterval(async () => {
                  try {
                    const response = await this.starthttprequest(
                      selectedsubmitdata
                    );
                    // Process the response
                    if (response.HasValidData) {
                      if (response.Data && response.Data.length > 0) {
                        // this.totalfiles.push(...response.Data); // Example processing, adjust as needed
                        // this.isFilenotAvailable = false;
                        if (this.totalfiles.length == 0) {
                          if (section == 'section6') {
                            this.fomInputPlayButtonEnable = true;
                          } else if (section == 'section7') {
                            this.fomFilePlayButtonEnable = true;
                          } else if (section == 'section9') {
                            this.isfinalLoadTrigger = true;
                          } else if (section == 'section4') {
                            this.timePeriodPlayButtonEnable = true;
                          } else {
                            this.isFilenotAvailable = true;
                          }
                          this.isButtonDisableWhenClickOnTrigger = false;
                        }
                      } else {
                        if (this.totalfiles.length == 0) {
                          if (section == 'section6') {
                            this.fomInputPlayButtonEnable = true;
                          } else if (section == 'section7') {
                            this.fomFilePlayButtonEnable = true;
                          } else if (section == 'section9') {
                            this.isfinalLoadTrigger = true;
                          } else if (section == 'section4') {
                            this.timePeriodPlayButtonEnable = true;
                          } else {
                            this.isFilenotAvailable = true;
                          }
                          this.isButtonDisableWhenClickOnTrigger = false;
                        }
                      }
                    }
                    // Example stopping condition
                    // if (this.totalfiles.length >= 10) { // Adjust this condition as needed
                    //     clearInterval(intervalId);
                    // }
                  } catch (error) {
                    console.error('Error in interval:', error);
                    clearInterval(this.intervalId); // Stop interval on error
                  }
                }, this.intervalTime);
              } else {
                this.fomFilePlayButtonEnable = true;
                this.fomInputPlayButtonEnable = true;
                this.isFilenotAvailable = true;
                this.isButtonDisableWhenClickOnTrigger = false;
                this.isfinalLoadTrigger = true;
                this.timePeriodPlayButtonEnable = true;
                this.IsUatLoadSelected = false;
                this.IsProdLoadSelected = false;
                this.IsDemoLoadSelected = false;
                this.isTPMtoggleOn = false;
                this.isTPMtoggleClicked = false;
              }
            } else {
              this.isButtonDisableWhenClickOnTrigger = false;
              this.IsUatLoadSelected = false;
              this.IsProdLoadSelected = false;
              this.IsDemoLoadSelected = false;
              this.isTPMtoggleOn = false;
              this.isTPMtoggleClicked = false;
            }
            // Hide the loader
            // this.isLoading = false;
          },
          (error) => {
            this.isTriggered[section] = false;
            this.isLoading = false;
            this.errorPopup('Error : ' + error.message);
            this.IsUatLoadSelected = false;
            this.IsProdLoadSelected = false;
            this.IsDemoLoadSelected = false;
            this.isTPMtoggleClicked = false;
            this.isTPMtoggleOn = false;
            this.isTPMtoggleClicked = false;
          }
        );
    } else {
      this.errorPopup('Please upload files');
    }
  }
  getJobNameBasedOnSection(section: string) {
    switch (section) {
      case 'section1':
        if (this.dropdownSelection.fileType.toLowerCase() == 'spss')
          return 'sanity_spss';
        if (this.dropdownSelection.fileType.toLowerCase() == 'gdf')
          return 'sanity_gdf';
        if (this.dropdownSelection.fileType.toLowerCase() == 'crdom')
          return 'sanity_crdom';
        if( this.dropdownSelection.fileType.toLowerCase() == 'csv')
          return 'sanity_csv';
        return 'sanity_spss';
      case 'section2':
        return 'inclusion';
      case 'section3':
        return 'variableMapping';
      case 'section4':
        return 'timeperiod';
      case 'section6':
        return 'fomInput';
      case 'section7':
        return 'fomFile';
      default:
        return 'finalLoad';
    }
  }
  OnDownloadFile(section: string, folderName: string) {
    this.isLoading = true;
    let multifolder: any;
    if (section.toLowerCase() == 'section2') {
      // if (this.statusdata[0].new_variable_file_flag) {
      //   multifolder = this.Folders.inclusion;
      // }
      // else {
      multifolder = this.Folders.inclusion;
      //multifolder = folderName;
      //}
    } else if (section.toLowerCase() == 'section4') {
      multifolder = this.Folders.timeperiod;
    } else {
      multifolder = folderName;
    }
    this.uploadService
      .downloadFile(this.dropdownSelection, folderName, multifolder)
      .subscribe((result: any) => {
        //validate the response
        if (result?.Data)
        {
          this.downloadPPTFile(result, multifolder);
        }

        // hide the loader
        this.isLoading = false;
      });
  }
  private downloadPPTFile(data: any, filename: string) {
    const filesJson = JSON.parse(data.Data);

    Object.keys(filesJson).forEach((fileName) => {
      const base64Content = filesJson[fileName].Base64Content;
      // Decode base64 content
      const binaryContent = atob(base64Content);
      // Convert binary content to ArrayBuffer
      const arrayBuffer = new ArrayBuffer(binaryContent.length);
      const uint8Array = new Uint8Array(arrayBuffer);
      for (let i = 0; i < binaryContent.length; i++) {
        uint8Array[i] = binaryContent.charCodeAt(i);
      }
      // Create blob from ArrayBuffer
      const blob = new Blob([arrayBuffer], {
        type: filesJson[fileName].FileExtension,
      });

      // Create link element for download
      const a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = filesJson[fileName].FileName;

      // Trigger download
      document.body.appendChild(a);
      a.click();
      // Cleanup
      document.body.removeChild(a);
      URL.revokeObjectURL(a.href);
    });
  }

  clearStudyData() {
    this.dropdownSelection.study = '';
    this.dropdownSelectedText.study = '';
    this.isStudySelected = false;
  }

  clearDataSourceData() {
    this.dropdownSelection.dataSource = '';
    this.dropdownSelectedText.dataSource = '';
    this.isDataSourceSelected = false;
  }

  clearDataProcessData() {
    this.dropdownSelection.dataProces = '';
    this.dropdownSelectedText.dataProces = '';
    this.isDataUpdateSelected = false;
  }

  clearDataFormat(){
    this.dropdownSelection.dataFormat = '';
    this.dropdownSelectedText.dataFormat = '';
    this.Filetypes = [];
    this.isDataFormatSelected = false;
  }
  clearFileTypeData() {
    this.dropdownSelection.fileType = '';
    this.dropdownSelectedText.fileType = '';
  }

  resetNextDropdownSections(section: string) {
    // Reset selected study when client changes
    switch (section.toLowerCase()) {
      case 'client':
        this.clearStudyData();
        this.clearDataSourceData();
        this.clearDataProcessData();
        this.clearDataFormat();
        this.clearFileTypeData();
        break;
      case 'study':
        this.clearDataSourceData();
        this.clearDataProcessData();
        this.clearDataFormat();
        this.clearFileTypeData();
        break;
      case 'datasource':
        this.clearDataProcessData();
        this.clearDataFormat();
        this.clearFileTypeData();
        break;
      case 'dataprocess':
        // if(this.dropdownSelectedText.dataProces != 'Restatement'){
          
        // }
        this.clearDataFormat();
        this.clearFileTypeData();
        break;
      case 'dataformat':
        this.clearFileTypeData();
        break;
      
    }
  }

  onClientChange(value: any, selecteddropdown: any) {
    this.hideMainDropDown('');
    this.UploadObject = [];
    this.Is_SubmitClick = false;
    this.uploadService.$submitClickEvent.next(false);

    if (selecteddropdown.toLowerCase() === 'client') {
      this.isStudySelected = false;
      let clientName = value;
      const selectedClient: any = this.UserClientStudyData.find(
        (client: { ClientName: string }) => client.ClientName === clientName
      );
      if (selectedClient) {
        this.dropdownSelection.client_name = clientName;
        this.dropdownSelectedText.client_name = clientName;
        let filteredData = selectedClient.UniqueStudies;
        filteredData = orderBy(filteredData, [(s) => s.toLowerCase()]);

        this.selectedClientStudies = filteredData;
        this.selectedClientStudies_MasterData = filteredData;
        this.isclientSelected = true;
        this.resetNextDropdownSections(selecteddropdown);
      } else {
        this.selectedClientStudies = [];
      }
    } else if (selecteddropdown.toLowerCase() === 'study') {
      if (this.isclientSelected) {
        let studyName = value;
        const selectedStudy: any = this.selectedClientStudies.find(
          (study) => study === studyName
        );
        if (selectedStudy) {
          this.isStudySelected = true;
          // this.selectedStudy = selectedStudy;
          this.dropdownSelection.study = selectedStudy;
          this.dropdownSelectedText.study = selectedStudy;         
          this.resetNextDropdownSections(selecteddropdown);
        } else {
        }
      } else {
        this.resetNextDropdownSections(selecteddropdown);
      }
    } else if (selecteddropdown.toLowerCase() === 'datasource') {
      let fileName = value;
      this.dropdownSelection.dataSource = fileName;
      let valSource: any = this.DataSource.find((s: any) => {
        return s.type === fileName;
      });
      if (valSource != undefined)
        this.dropdownSelectedText.dataSource = valSource.name;

      this.isDataSourceSelected = true;
      //Selecting upload data by default;
      this.resetNextDropdownSections(selecteddropdown);
      this.getDefaultData();
      this.isDataUpdateSelected = true;
      this.isDataFormatSelected = true;
      this.isDataFormatDropdownDisabled = true;
      this.dropdownSelection.dataProces = this.DataProcessTypes[0].type;
      this.dropdownSelectedText.dataProces = this.DataProcessTypes[0].process;
    } else if (selecteddropdown.toLowerCase() === 'dataprocess') {
      let fileName = value;
      this.dropdownSelection.dataProces = fileName;
      let valSource: any = this.DataProcessTypes.find((s: any) => {
        return s.type === fileName;
      });
      if (valSource != undefined)
        this.dropdownSelectedText.dataProces = valSource.process;
      // if(this.dropdownSelectedText.dataProces != 'Restatement'){
      //   this.isDataUpdateSelected = true;
      // }else{
      //   this.Filetypes = this.FiletypesForRespondent;
      //   this.isDataFormatSelected = true;
      // }
      this.isDataUpdateSelected = true;
      this.resetNextDropdownSections(selecteddropdown);
      this.getDefaultData();
      this.isDataFormatSelected = true;
      this.isDataFormatDropdownDisabled = true;
      //this.Is_Submit = true;
      // this.UploadObject.push(this.dropdownSelection);
    } else if (selecteddropdown.toLowerCase() === 'dataformat'){
      let dataFormatName = value;
      
      let valSource: any = this.DataFormat .find((s: any) => {
        return s.dataFormatType === dataFormatName;
      });
      if (valSource != undefined){
        this.dropdownSelection.dataFormat = valSource.value;
        this.dropdownSelectedText.dataFormat = valSource.dataFormatType;
        if(this.dropdownSelectedText.dataFormat.toLowerCase().includes("aggregated")){
          this.Filetypes = this.FiletypesForAggregated;
        }else{
          this.Filetypes = this.FiletypesForRespondent;
        }
        this.isDataFormatSelected = true;
        this.resetNextDropdownSections(selecteddropdown.toLowerCase());
      }
    } 
    else {
      let fileName = value;
      this.dropdownSelection.fileType = fileName;
      this.dropdownSelectedText.fileType = fileName;
    }
    if (
      this.dropdownSelection.client_name != '' &&
      this.dropdownSelection.dataProces != '' &&
      this.dropdownSelection.fileType != '' &&
      this.dropdownSelection.study != ''
    ) {
      //this.UploadObject.push(this.dropdownSelection);
      this.Is_Submit = true;
    } else {
      this.Is_Submit = false;
    }
  }

  getDefaultData(): void {
    this.isLoading = true;
    this._configService.getDefaultConfigurations().subscribe((result: results) => {
      if (result.HasValidData) {
        this.configData = JSON.parse(result.Data);

        const data: ClientStudy = {
          client_name: this.dropdownSelection.client_name,
          study: this.dropdownSelection.study
        };
        this.getClientStudy(data);
      }
      else
      {
        this.isLoading = false;
      }
    });
  }

  getClientStudy(clientStudydetails: ClientStudy): void {
    this._configService.getClientStudyData(clientStudydetails).subscribe((result: results) => {
      if (result.HasValidData) {
        this.configDataFormat = JSON.parse(result.Data).configData.dataformat;

        const configKey = this.configDataFormat.find((x: any) => x.value === true)?.key;
        let selectedFormat;
        this.DataFormat.forEach(f => f.disabled = false);
        if (configKey && configKey.toLowerCase().includes('respondent')) {
          selectedFormat = this.DataFormat.find(f => f.dataFormatType === 'Respondent level');
          const aggregatedFormat = this.DataFormat.find(f => f.dataFormatType === 'Aggregated/Semi Aggregated');
        if (aggregatedFormat) aggregatedFormat.disabled = true;
        } else {
          selectedFormat = this.DataFormat.find(f => f.dataFormatType === 'Aggregated/Semi Aggregated');
          const respondentFormat = this.DataFormat.find(f => f.dataFormatType === 'Respondent level');
        if (respondentFormat) respondentFormat.disabled = true;
        }
        
        if (selectedFormat) {
          this.dropdownSelection.dataFormat = selectedFormat.value;
          this.dropdownSelectedText.dataFormat = selectedFormat.dataFormatType;
               
          if(this.dropdownSelectedText.dataFormat.toLowerCase().includes("aggregated")){
            this.Filetypes = this.FiletypesForAggregated;
          }else{
            this.Filetypes = this.FiletypesForRespondent;
          }        
        }
      }
      this.isLoading = false;
    });
  }

  mainDropdownList: any = {
    client: false,
    study: false,
    dataProces: false,
    dataSource: false,
    fileType: false,
    dataFormat : false,
  };

  toggleMainDropDown(event: any, selecteddropdown: string) {
    this.hideMainDropDown(selecteddropdown);

    this.mainDropdownList[selecteddropdown] =
      !this.mainDropdownList[selecteddropdown];
  }

  clearSearch() {
    let drpList = document.getElementById('dropdownid_container');
    let txtBoxList = drpList?.querySelectorAll('.text-box-search');
    if (txtBoxList != undefined) {
      txtBoxList.forEach((input) => {
        (input as HTMLInputElement).value = '';
      });
    }

    this.UserClientStudyData = JSON.parse(
      JSON.stringify(this.UserClientStudyData_MasterData)
    );
    this.selectedClientStudies = JSON.parse(
      JSON.stringify(this.selectedClientStudies_MasterData)
    );
  }

  hideMainDropDown(selecteddropdown: string) {
    forEach(this.mainDropdownList, (s: any, key: any) => {
      if (key != selecteddropdown) {
        this.mainDropdownList[key] = false;
      }
    });
    this.clearSearch();
  }

  ngOnDestroy() {
    if (this.$unSubscribeSubmitData1) {
      this.$unSubscribeSubmitData1.unsubscribe();
    }
    if (this.intervalId != null && this.intervalId != undefined) {
      clearInterval(this.intervalId);
    }
  }

  getMarginForScroll() {
    let tblRef: any = document.getElementById('grid_table_container_upload');
    if (tblRef != null) {
      let theadRef = tblRef.getElementsByTagName('thead');
      if (theadRef != null && theadRef.length > 0) {
        return `${theadRef[0].clientHeight}px 0 0 0px`;
      }
    }
    return 0;
  }

  @HostListener('document:click', ['$event'])
  handleDocumentClick(event: MouseEvent) {

    if( !this.isClickInside(event, '.setting-dropdown') && !this.isClickInside(event,'.emailIcon')){
      this.showSettingDropdown = false;
      this.settingIconsButton.forEach((icons:any) => {
        icons.isSelected = false;
      })
    }
    
    if (!this.isClickInside(event, '.client_dropdown')) {
      forEach(this.mainDropdownList, (s: any, key: any) => {
        this.mainDropdownList[key] = false;
      });
    }
    if (!this.isClickInside(event, '.client_dropdown_index')) {
      this.isToggleDropdown = false;
    }

    // Add logic to handle the click
  }

  private isClickInside(event: Event, className: string): boolean {
    const elements = document.querySelectorAll(className);
    for (let i = 0; i < elements.length; i++) {
      const container = elements[i];
      if (container.contains(event.target as Node)) {
        return true;
      }
    }
    return false;
  }

  filterData(e: any, clientName: string) {
    const inputElement = e.target as HTMLInputElement;
    const searchTerm = inputElement.value.toLowerCase();

    if (clientName == 'client') {
      if (e != '') {
        this.UserClientStudyData = this.UserClientStudyData_MasterData.filter(
          (client: any) => client.ClientName.toLowerCase().includes(searchTerm)
        );
      }
    } else if (clientName == 'study') {
      if (e != '') {
        this.selectedClientStudies =
          this.selectedClientStudies_MasterData.filter((st: any) =>
            st.toLowerCase().includes(searchTerm)
          );
      }
    }
  }

  getEmailIdList() {
    this.submittedAdminEmailList = [];
    this.submittedOthersEmailList = [];
    this.emailList = [];
    this.adminEmailIDList = [];
    this.nonadminEmailIDList = [];
    this.emailExistingList = [];
    this.isLoading = true;
    this.uploadService
      .getEmailList(this.UploadObject[0])
      .subscribe((result: any) => {
        if (result) {
          let resData = JSON.parse(result.users);
          this.emailList = orderBy(JSON.parse(resData.Data), [
            (s) => s['email'].toLowerCase(),
          ]);

          this.emailList = uniqBy(this.emailList, 'email');
          this.emailExistingList = result.existingData;

          this.getNewEmailList = false;

          //Super Administ
          this.adminEmailIDList = this.emailList.filter((x: any) => {
            if (x.super_admin == true) {
              x.is_selected = false;
              return x;
            }
          });
          let existingUsers: any = this.emailExistingList.map(
            (s: any) => s.email_id_admin
          );
          if (existingUsers.length > 0 && existingUsers[0] != '') {
            let existingUsersList = existingUsers[0].split(',');
            this.adminEmailIDList.map((s: any) => {
              if (existingUsersList.includes(s.email)) {
                s.is_selected = true;
                this.submittedAdminEmailList.push(s.email);
              }
            });
          }

          //If super admin is selected and other users making non selected by default
          let selectedAdminListEmpty = existingUsers[0] == '' ? true : false;
          //other users list
          this.nonadminEmailIDList = this.emailList.filter((x: any) => {
            if (x.super_admin == false) {
              x.is_selected = selectedAdminListEmpty ? true : false;
              if (x.is_selected) this.submittedOthersEmailList.push(x.email);
              return x;
            }
          });

          let existingOtherUsers: any = this.emailExistingList.map(
            (s: any) => s.email_id_others
          );
          if (existingOtherUsers.length > 0 && existingOtherUsers[0] != '') {
            let existingOtherUsersList = existingOtherUsers[0].split(',');
            this.submittedOthersEmailList = [];
            this.nonadminEmailIDList.map((s: any) => {
              if (existingOtherUsersList.includes(s.email)) {
                s.is_selected = true;
                this.submittedOthersEmailList.push(s.email);
              } else s.is_selected = false;
            });
          }

          this.checkPopupEnableSubmit();

          //Stroring data in service
          this.uploadService.storedEmailListData({
            admin: this.submittedAdminEmailList,
            user: this.submittedOthersEmailList,
          });

          // //Calling uploadService
          // this.starthttprequest(this.UploadObject[0]);
        } else {
          this.isLoading = false;
          if (!this.isErrorpopupshown) {
            this.errorPopup(result.users.ExceptionMessage);
            this.isErrorpopupshown = true;
          }
        }
      });
  }

  openEmailList() {
    this.searchTermAdmin = '';
    this.searchTermOthers = '';
    this.enableEmailSubmit = false;

    //Admin list
    if (this.submittedAdminEmailList.length > 0) {
      this.adminEmailIDList.map((s: any) => {
        if (this.submittedAdminEmailList.includes(s.email)) {
          s.is_selected = true;
          s.sort_id = 1;
        } else {
          s.is_selected = false;
          s.sort_id = 2;
        }
      });
      this.adminEmailIDList = orderBy(this.adminEmailIDList, (s) => s.sort_id);
    }

    //Other user list
    if (this.submittedOthersEmailList.length > 0) {
      this.nonadminEmailIDList.map((s: any) => {
        if (this.submittedOthersEmailList.includes(s.email)) {
          s.sort_id = 1;
          s.is_selected = true;
        } else {
          s.sort_id = 2;
          s.is_selected = false;
        }
      });
      this.nonadminEmailIDList = orderBy(
        this.nonadminEmailIDList,
        (s) => s.sort_id
      );
    }

    this.checkPopupEnableSubmit();
    //Stroring data in service
    this.uploadService.storedEmailListData({
      admin: this.submittedAdminEmailList,
      user: this.submittedOthersEmailList,
    });

    this.showEmailPopup = !this.showEmailPopup;
  }

  toggleEmailIDoption(query: any, type: string) {
    if (query) {
      //if (type == "admin")
      query.is_selected = !query.is_selected;

      if (query.is_selected) this.enableEmailSubmit = true;
      else this.checkPopupEnableSubmit();
    }
  }

  checkPopupEnableSubmit() {
    this.enableEmailSubmit = false;
    let otherSel: any = this.nonadminEmailIDList.find(
      (x: any) => x.is_selected == true
    );

    if (otherSel != undefined) {
      this.enableEmailSubmit = true;
      return;
    }

    let adminSel: any = this.adminEmailIDList.find(
      (x: any) => x.is_selected == true
    );
    if (adminSel != undefined) {
      this.enableEmailSubmit = true;
      return;
    }
  }

  closeEmailClick() {
    this.showEmailPopup = false;
  }

  OnEmailSubmitClick() {
    this.submittedOthersEmailList = [];
    this.submittedAdminEmailList = [];
    let otherSel: any = this.nonadminEmailIDList.filter(
      (x: any) => x.is_selected == true
    );
    let otherSelList = '';
    if (otherSel.length > 0) {
      this.submittedOthersEmailList = otherSel.map((p: any) => p.email);
      otherSelList = this.submittedOthersEmailList.join(',');
    }

    let adminSel: any = this.adminEmailIDList.filter(
      (x: any) => x.is_selected == true
    );

    let adminSelList = '';
    if (adminSel.length > 0) {
      this.submittedAdminEmailList = adminSel.map((p: any) => p.email);
      adminSelList = this.submittedAdminEmailList.join(',');
    }

    this.isLoading = true;

    let jsonData = {
      study: this.UploadObject[0].study,
      client: this.UploadObject[0].client_name,
      modified_by: '',
      email_id_admin: adminSelList,
      email_id_others: otherSelList,
    };

    //Stroring data in service
    this.uploadService.storedEmailListData({
      admin: this.submittedAdminEmailList,
      user: this.submittedOthersEmailList,
    });

    this.uploadService.updateEmailList(jsonData).subscribe((result: any) => {
      if (result.HasValidData) {
        let msg = result.Data;
        if (!this.isErrorpopupshown) {
          this.errorPopup(msg, 'Success');
          this.isErrorpopupshown = true;
        }
        this.isLoading = false;
      } else {
        this.isLoading = false;
        if (!this.isErrorpopupshown) {
          this.errorPopup('Something went wrong, please try again');
          this.isErrorpopupshown = true;
        }
      }
      this.closeEmailClick();
    });
  }

  OnSettingClick(){
    this.showSettingDropdown = !this.showSettingDropdown 
  }

  OnSettingsSel(item: any) {
    switch (item) {
      case this.settingOptionList.ReportIssue:
        this.isReportIssue = true;
        break;
      case this.settingOptionList.ExportDownload:
        // Handle export downloads if needed
        break;
    }
  }

  handleSettingClick(events:any){
    this.selectedDeletes.forEach((items:any)=>{
      items.isSelected = false;
    })

    events.isSelected = !events.isSelected;
    this.settingIconsButton.forEach((icons:any) => {
      if(icons.iconId != events.iconId){
        icons.isSelected = false;
      }
    })


    if(events.iconId.toLowerCase() == 'email_list'){
      this.openEmailList();
      this.showSettingDropdown = false;
    }
    else if( events.iconId.toLowerCase() == 'user_log'){
      this.showSettingDropdown = false;
      this.DownloadUsageLogReport()
    }
  }

  // onDeleteClick(parameter:string){

  // }

  onDeleteClick(parameter:string){

    // this.expectItemtoRemoveOrRevert = item;
    let message= "Are you sure you want to delete the selected items? Select Confirm to proceed or Cancel to go back.";

    this.confirmationType = this.selectedDeletes.filter((item:any) => item.isSelected)

    // if(parameter == 'deleteAll'){
    //   this.confirmationType = "all";
    //   message = `Are you sure want to "Delete All"?`;
    // }else if( parameter == 'mapping' ){
    //   this.confirmationType = 'mapping';
    //   message = `Are you sure want to delete "Mapping"?`;
    // }else{
    //   this.confirmationType = 'data'
    //   message = `Are you sure want to delete "Data"?`;
    // }

    
    // Prepare the confirmation message
    
    // Show the confirmation dialog with the prepared message
    this.showConfirmationDialog(message,false);
  }

  onTriggerClick(parameter:string){

    let message= "Are you sure you want to trigger alert for the selected items? Select Confirm to proceed or Cancel to go back.";

    this.confirmationType = this.selectedAlerts.filter((item:any) => item.isSelected)

    
    // Prepare the confirmation message
    
    // Show the confirmation dialog with the prepared message
    this.showConfirmationDialog(message,false);
  }

  showConfirmationDialog(message: string, option:boolean) {
    // Set the confirmation message for the dialog
    this.confirmationMessage = message;
    // Set the flag to show the confirmation dialog
    this.isShowDialog = true;
    this.secondPopupEnabled = option;
  }

  onConfirmation(operation: number) {
    // if (operation === 1) {
    //   // If the action is confirmed, execute the corresponding action based on the confirmation type

    //   this.DeleteClientDataOrMapping(this.confirmationType)
    //   // Hide the dialog after executing the action
    //   this.isShowDialog = false;
    // } else {
    //   // User canceled the action, hide the dialog
    //   this.isShowDialog = false;
    // }
    if(operation == 1){
      if(this.secondPopupEnabled){
        this.secondPopupEnabled = false;
        this.isShowDialog = false;
        
        const isDeleteType = this.confirmationType.some((ct: { displayName: string; }) => 
          this.selectedDeletes.some(sd => sd.displayName === ct.displayName)
        );

        if (isDeleteType) {
          this.DeleteClientDataOrMapping(this.confirmationType);
        } else {
          this.TriggerAlerts(this.confirmationType);
        }

        //this.DeleteClientDataOrMapping(this.confirmationType);
      }
      else{
        let message = "";
        if(this.settingIconsButton[0].isSelected)
        {
          message = "Please note that deleted items cannot be restored. Select Confirm to proceed or Cancel to go back.";
        }
        else if(this.settingIconsButton[4].isSelected)
        {
          message = "Please note that selected items cannot be reverted from alert. Select Confirm to proceed or Cancel to go back.";
        }
        this.isShowDialog = false;
        this.showConfirmationDialog(message,true);
      }
    }
    else{
      this.isShowDialog = false;
      this.clearSelectedDeletes();
    }
  }

  clearSelectedDeletes(): void {
    this.selectedDeletes.forEach(item => {
      item.isSelected = false;
    });
  }
  

  DeleteClientDataOrMapping(parameter:string){
    this.isLoading = true;
    let emailData: any = this.uploadService.getStoredEmailListData();
    this.uploadService
      .deleteDataOrMapping(
        this.UploadObject[0],
        parameter,
        emailData
      )
      .subscribe(
        (res: any) => {
          if (res.HasValidData) {
            this.isLoading = false;
            let popupHeader;
            if(res.Data.includes("Successfully")){
              popupHeader = "Success";
            }else{
              popupHeader = "Error";
            }
            this.errorPopup(res.Data, popupHeader);
            // Resolve the promise with the response
          } else {
            this.isLoading = false;
            if (!this.isErrorpopupshown) {
              this.errorPopup(res.ExceptionMessage);
              this.isErrorpopupshown = true;
            }
          }
        },
        (error) => {
          this.isLoading = false;
        }
      );
  }

  TriggerAlerts(parameter:string){
    this.isLoading = true;
    this.uploadService
      .triggerAlerts(
        this.dropdownSelection,  
        parameter
      )
      .subscribe(
        (res: any) => {
          if (res.HasValidData) {
            this.isLoading = false;
             let popupHeader = "Information";
            // if(res.Data.includes("Successfully")){
            //   popupHeader = "Information";
            // }else{
            //   popupHeader = "Information";
            // }
            this.errorPopup(res.Data, popupHeader);
            // Resolve the promise with the response
          } else {
            this.isLoading = false;
            if (!this.isErrorpopupshown) {
              this.errorPopup(res.ExceptionMessage);
              this.isErrorpopupshown = true;
            }
          }
        },
        (error) => {
          this.isLoading = false;
        }
      );
  }

  DownloadBlankTemplatesFiles(){

    this.isLoading = true; // Show loader indicating processing
    // Call the UpdateDownloadedStatus() service method to update the download status of the report
    this.uploadService.downloadBlankTemplates(this.UploadObject[0]).subscribe(
      // If the update is successful, receive the Excel file as a Blob
      (excelBlob: Blob) => {
        // Get the current date and time
        //let datetime = this._exportDownloadService .getCurrentDateTime();
        let fileName="Blank Template files.zip";
        // if(report.report_type=="Crosstab")
        //  fileName =`KantarXTab_${report.client_name}_${report.study_name}_${datetime}.xlsx`;
        // else if(report.report_type=="CustomReport")
        //   fileName =`${report.selection_summary}_${datetime}.zip`;
        // else
        // fileName =`${report.selection_summary}.xlsx`;
        // Trigger the download of the Excel file with a filename based on the report ID and current datetime
        this.uploadService.downloadBlankTemplateFiles(excelBlob, fileName);
        
        // Hide the loader after processing is complete
        this.isLoading = false;
      },
      // If there's an error during the download process, handle it
      (error) => {
        // Log and display an error message if there is an issue with the download
        console.error('Error exporting to Excel', error);
        //this.AlertPopup('Something went wrong, please try again');
        // Hide the loader after handling the error
        this.isLoading = false;
      }
    );

  }

  DownloadLatestMappingFiles(){
    this.isLoading = true; // Show loader indicating processing
    // Call the UpdateDownloadedStatus() service method to update the download status of the report
    this.uploadService.downloadLatestMappingfiles(this.UploadObject[0]).subscribe(
      // If the update is successful, receive the Excel file as a Blob
      (result:any) => {
        // Get the current date and time
        //let datetime = this._exportDownloadService .getCurrentDateTime();
        //let fileName="Blank Template files.zip";
        // Trigger the download of the Excel file with a filename based on the report ID and current datetime
        //this.uploadService.downloadBlankTemplateFiles(excelBlob, fileName);
        if( result.Data != null && result.Data.includes("FileNotFound")){
          let message = "No files Exists to Download";
          let popupHeader = "Information";
          this.isLoading = false;
          this.errorPopup(message, popupHeader);
        }else{
          this.downloadMappingfiles(result);
        }
        
        //this.downloadPPTFile(result,"");
      },
      // If there's an error during the download process, handle it
      (error) => {
        // Log and display an error message if there is an issue with the download
        console.error('Error exporting to Excel', error);
        //this.AlertPopup('Something went wrong, please try again');
        // Hide the loader after handling the error
        this.isLoading = false;
      }
    );
  }

  DownloadMappingInputs(){
    this.isLoading = true; // Show loader indicating processing
    // Call the UpdateDownloadedStatus() service method to update the download status of the report
    this.uploadService.downloadMappingInputs(this.UploadObject[0]).subscribe(
      // If the update is successful, receive the Excel file as a Blob
      (result:any) => {
        // Get the current date and time
        //let datetime = this._exportDownloadService .getCurrentDateTime();
        //let fileName="Blank Template files.zip";
        // Trigger the download of the Excel file with a filename based on the report ID and current datetime
        //this.uploadService.downloadBlankTemplateFiles(excelBlob, fileName);
        if( result.Data != null && result.Data.includes("FileNotFound")){
          this.DownloadBlankMappingInputs();
        }else{
          this.downloadMappinginputs(result);
        }
        
        //this.downloadPPTFile(result,"");
      },
      // If there's an error during the download process, handle it
      (error) => {
        // Log and display an error message if there is an issue with the download
        console.error('Error exporting to Excel', error);
        //this.AlertPopup('Something went wrong, please try again');
        // Hide the loader after handling the error
        this.isLoading = false;
      }
    );
  }

  DownloadBlankMappingInputs(){
    // Create an empty ZIP file blob and download it
    const emptyBlob = new Blob([], { type: 'application/zip' });
    this.uploadService.downloadBlankTemplateFiles(emptyBlob, "Mapping Inputs.zip");
    this.isLoading = false;
  }

  downloadMappingfiles(data: any) {
    const filesJson = JSON.parse(data.Data);
    
    // Create a new JSZip instance
    const zip = new JSZip();
  
    // Loop through each file and add it to the zip file
    Object.keys(filesJson).forEach((fileName) => {
      const base64Content = filesJson[fileName].Base64Content;
      // Decode base64 content
      const binaryContent = atob(base64Content);
      // Convert binary content to ArrayBuffer
      const arrayBuffer = new ArrayBuffer(binaryContent.length);
      const uint8Array = new Uint8Array(arrayBuffer);
      for (let i = 0; i < binaryContent.length; i++) {
        uint8Array[i] = binaryContent.charCodeAt(i);
      }
      
      // Add file to the zip
      zip.file(filesJson[fileName].FileName, arrayBuffer);
    });
  
    // Generate the zip file asynchronously
    zip.generateAsync({ type: 'blob' }).then((content) => {
      // Create a link element to download the zip file
      const a = document.createElement('a');
      a.href = URL.createObjectURL(content);
      a.download = "Latest Mapping Files";  // Set the zip file name
      document.body.appendChild(a);
      a.click();
      this.isLoading = false;
      // Cleanup
      document.body.removeChild(a);
      URL.revokeObjectURL(a.href);
    });
  }

  downloadMappinginputs(data: any) {
    const filesJson = JSON.parse(data.Data);
    
    // Create a new JSZip instance
    const zip = new JSZip();
  
    // Loop through each file and add it to the zip file
    Object.keys(filesJson).forEach((fileName) => {
      const base64Content = filesJson[fileName].Base64Content;
      // Decode base64 content
      const binaryContent = atob(base64Content);
      // Convert binary content to ArrayBuffer
      const arrayBuffer = new ArrayBuffer(binaryContent.length);
      const uint8Array = new Uint8Array(arrayBuffer);
      for (let i = 0; i < binaryContent.length; i++) {
        uint8Array[i] = binaryContent.charCodeAt(i);
      }
      
      // Add file to the zip
      zip.file(filesJson[fileName].FileName, arrayBuffer);
    });
  
    // Generate the zip file asynchronously
    zip.generateAsync({ type: 'blob' }).then((content) => {
      // Create a link element to download the zip file
      const a = document.createElement('a');
      a.href = URL.createObjectURL(content);
      a.download = "Mapping Inputs";  // Set the zip file name
      document.body.appendChild(a);
      a.click();
      this.isLoading = false;
      // Cleanup
      document.body.removeChild(a);
      URL.revokeObjectURL(a.href);
    });
  }

  OnLoadClicked(server:string){
    this.selectedEnvironment = ""
    if(server == 'uat'){
      this.IsUatLoadSelected = !this.IsUatLoadSelected;
      this.IsProdLoadSelected = false;
      this.IsDemoLoadSelected = false;

      if(this.IsUatLoadSelected){
        this.selectedEnvironment = "uat"
      }

    }else if(server == 'demo'){  
      this.IsUatLoadSelected = false;
      this.IsProdLoadSelected = false;
      this.IsDemoLoadSelected = !this.IsDemoLoadSelected;

      if( this.IsDemoLoadSelected){
        this.selectedEnvironment = 'demo'
      }

    }else if( server = 'prod'){
      this.IsUatLoadSelected = false;
      this.IsProdLoadSelected = !this.IsProdLoadSelected;
      this.IsDemoLoadSelected = false;

      if(this.IsProdLoadSelected){
        this.selectedEnvironment = 'prod'
      }
    }
  }

  onToggleClick(section:string){
    if(section == 'tpm'){
      this.isTPMtoggleClicked = !this.isTPMtoggleClicked;
      if( this.isTPMtoggleClicked){
        this.BindFileName.timeperiodInput = "TPM File";
      }else{
        this.BindFileName.timeperiodInput = this.inputFileName.timeperiodInput;
      }
    }

    if(section == 'fom'){
      this.isFOMtoggleClicked = !this.isFOMtoggleClicked;
    }
  }
}
